import axios from "axios";

// const API_URL = "http://localhost:4000/api/";
const API_URL = "https://diucapstone1.onrender.com/api/";

// Create a new product
const createProduct = async (productData, token) => {
  //   console.log(productData);
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.post(
      API_URL + "admin/product/new",
      productData,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//http://localhost:4000/api/products?page=1&limit=4&category=Laptop,Monitor&sort=price,desc&search=apple&minPrice=135000&maxPrice=142000

// Get all products
const getAllProducts = async ({
  sort,
  filterCategory,
  currentPage,
  search,
}) => {
  const page = currentPage;

  // console.log(
  //   `${API_URL}products?page=${page}&limit=3&sort=${sort.sort},${
  //     sort.order
  //   }&category=${filterCategory.toString()}&search=${search}`
  // );

  try {
    const response = await axios.get(
      `${API_URL}products?page=${page}&limit=5&sort=${sort.sort},${
        sort.order
      }&category=${filterCategory.toString()}&search=${search}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get feature product
const getFeatureProduct = async () => {
  try {
    const response = await axios.get(`${API_URL}products/feature`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get feature product
const addAndRemoveWishList = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.put(
      `${API_URL}products/wishlist`,
      { prodId: id },
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// getWishList

const getWishList = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.get(`${API_URL}products/wishlist`, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get admin products (protected route)
const getAdminProducts = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await axios.get(API_URL + "admin/products", config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update a product by ID (protected route)
const updateProduct = async (productId, updatedProductData) => {
  try {
    const response = await axios.put(
      API_URL + `admin/product/${productId}`,
      updatedProductData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Add your authentication token logic here
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a product by ID (protected route)
const deleteProduct = async (productId) => {
  try {
    const response = await axios.delete(
      API_URL + `admin/product/${productId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Add your authentication token logic here
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get product details by ID
const getProductDetails = async (productId) => {
  try {
    const response = await axios.get(API_URL + `product/${productId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create a product review (protected route)
const createProductReview = async (reviewData, token) => {
  try {
    const response = await axios.post(API_URL + "review", reviewData, {
      headers: {
        Authorization: `Bearer ${token}`, // Add your authentication token logic here
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get product reviews
const getProductReviews = async () => {
  try {
    const response = await axios.get(API_URL + "reviews");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a review by ID (protected route)
const deleteReview = async (reviewId) => {
  try {
    const response = await axios.delete(API_URL + "reviews", {
      data: { reviewId },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`, // Add your authentication token logic here
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const productService = {
  createProduct,
  getAllProducts,
  getAdminProducts,
  updateProduct,
  deleteProduct,
  getProductDetails,
  createProductReview,
  getProductReviews,
  deleteReview,
  getFeatureProduct,
  addAndRemoveWishList,
  getWishList,
};

export default productService;
